import React from "react"
import { bkPopUp, clPopUp } from "./general"

export default function PopUpIncidente({ incidente, top, left, set }) {

    const Sincidente = {
        position: "fixed",
        top: top,
        left: left,
        background: bkPopUp,
        color: clPopUp,
        fontSize: "1.7vh",
        border: `1px solid ${clPopUp}`,
        padding: "15px 5px 15px 5px",
        width: "25vw",
        maxHeight: "15vh",
    }

    return (
        <div style={Sincidente}>
            <div style={Sdescripcion} onClick={() => set(null)}>
                {incidente.descripcion}
            </div>
            {incidente.nuevoUsr !== "" && < div > <b>Viene de: </b>{incidente.responsable}</div>}
        </div >
    )
}

const Sdescripcion = {
    width: "95%",
    maxHeight: "85%"
}
